
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/context/auth-context";

export const AuthGuard = () => {
  const { user, isInitialized } = useAuth();
  const location = useLocation();

  // Show nothing while checking authentication status
  if (!isInitialized) {
    return null;
  }

  if (!user) {
    // Redirect to login but save the attempted URL
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};
